export default __webpack_public_path__ + "static/media/QWE.c7e123eb.jpg";